import { ai2htmlResize } from './utils/ai2html-resizer';

ai2htmlResize('#g-la-fire-fighting-solutions-neighborhood-box');
